import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=3d967ea5&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"
import style0 from "./Options.vue?vue&type=style&index=0&id=3d967ea5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d967ea5",
  null
  
)

export default component.exports